export const specialFiltersData : string[] = [
    'Disabled',
    'LGBTQ+',
    'Black/African American',
    'Alaska Native',
    'Hispanic/Latino/Latina',
    'Asian/Pacific Islander',
    'Native American',
    'Military'
]